import { Smartphone } from "lucide-react";
import { Loading, Stat, useAdmin } from "./ui";

export const AppInstalls = () => {
  const { data } = useAdmin("app-installs", "/admin/analytics/app");
  if (!data) return <Loading />;
  const b = data.by_platform;
  return (
    <div className="ad-card ai-card" data-testid="app-installs-card">
      <h3><Smartphone size={16} /> App installs</h3>
      <div className="ad-stats">
        <Stat label="Total installs" value={data.total} testId="app-installs-total" />
        <Stat label="Last 30 days" value={data.last_30} testId="app-installs-30" />
        <Stat label="Opened this month" value={data.active_month} hint="people using the app" testId="app-installs-active" />
      </div>
      <div className="ai-split" data-testid="app-installs-split">
        <span data-testid="app-installs-ios">iPhone <strong>{b.ios}</strong></span>
        <span data-testid="app-installs-android">Android <strong>{b.android}</strong></span>
        <span data-testid="app-installs-desktop">Computer <strong>{b.desktop}</strong></span>
      </div>
      <p className="muted-sm">iPhone installs are counted the first time the app is opened from the home screen.</p>
    </div>
  );
};
